import { FC } from 'react';
import { useLocation } from 'react-router';

import { StudioPageProps } from '../../hooks';
import { withStageNavRedirect } from '../redirect-into-stage-nav';
import { ActionsRedirect as ActionsRedirectPage } from './actions-redirect';
import { FilesLayout as FilesLayoutPage } from './files-layout';

// With the 5-stage nav on, Files lives in Build (Project Bobcat): Media is a
// Build tab, and Actions the panel the Build bar's Actions button opens. Off,
// the pages render as before.
const FilesIntoBuild = withStageNavRedirect(FilesLayoutPage, {
  stage: 'build',
  buildViewMode: 'files',
});
const ActionsIntoBuild = withStageNavRedirect(FilesLayoutPage, {
  stage: 'build',
  openActions: true,
});

export const FilesLayout: FC<StudioPageProps> = (props) => {
  const { pathname } = useLocation();
  return /\/files\/actions\/?$/.test(pathname) ? (
    <ActionsIntoBuild {...props} />
  ) : (
    <FilesIntoBuild {...props} />
  );
};

export const ActionsRedirect = withStageNavRedirect(ActionsRedirectPage, {
  stage: 'build',
  openActions: true,
});
